interface FloatMenuContextType {
  id: string
  isOpen: Ref<boolean>
  onSelect: (key: unknown, ignoreClose?: boolean) => void
  toggle: (value?: boolean) => void
  itensClass: string
}

export const FloatMenuContextKey = Symbol('FloatMenuContext') as InjectionKey<FloatMenuContextType>

export const useFloatMenu = () => {
  const id = randomID()
  const itensClass = `menuitem-${id}`
  const context = inject(FloatMenuContextKey, {
    id,
    isOpen: ref(false),
    onSelect: () => {},
    toggle: () => {},
    itensClass,
  })

  return context
}
